<template>
  <div>
    <p class="h3 mb-2 pt-2 pb-4">Pour commencer, sélectionnez votre type d’habitation</p>

    <div class="form-check check-tile mb-3" @click="setData('house_type','habitation-bbc')">
      <input class="form-check-input d-none" type="radio" name="step-1" id="exampleRadios1" value="option1" checked>
      <router-link tag="label" :to="{name:'RegionSelection'}" class="form-check-label" for="exampleRadios1">
        <div class="d-flex align-items-center">
          <img src="../assets/img/habitations/habitation-bbc.svg">
          <div class="ml-4">
            <p class="mb-0 lead">Habitation neuve</p>
            <span class="text-secondary">Construite à partir de 2010</span>
          </div>
        </div>
        <i class="fal fa-arrow-right fa-2x text-primary"></i>
      </router-link>
    </div>

    <div class="form-check check-tile mb-3" @click="setData('house_type','habitation-bien-isole')">
      <input class="form-check-input d-none" type="radio" name="step-1" id="exampleRadios2" value="option2">
      <router-link tag="label" :to="{name:'RegionSelection'}" class="form-check-label" for="exampleRadios2" >
        <div class="d-flex align-items-center">
          <img src="../assets/img/habitations/habitation-bien-isole.svg">
          <div class="ml-4">
            <p class="mb-0 lead">Habitation bien isolée</p>
            <span class="text-secondary">Construite entre 1975 et 2010</span>
          </div>
        </div>
        <i class="fal fa-arrow-right fa-2x text-primary"></i>
      </router-link>
    </div>

    <div tag="div" class="form-check check-tile" @click="setData('house_type','habitation-mal-isole')">
      <input class="form-check-input d-none" type="radio" name="step-1" id="exampleRadios3" value="option2">
      <router-link tag="label" :to="{name:'RegionSelection'}" class="form-check-label" for="exampleRadios3">
        <div class="d-flex align-items-center">
          <img src="../assets/img/habitations/habitation-mal-isole.svg">
          <div class="ml-4">
            <p class="mb-0 lead">Habitation mal isolée</p>
            <span class="text-secondary">Construite avant 1975</span>
          </div>
        </div>
        <i class="fal fa-arrow-right fa-2x text-primary"></i>
      </router-link>
    </div>
  </div>

</template>

<script>
export default {
  name: "HouseType",
  mounted(){
    if (this.state.selected_region)this.setData('selected_region',null);
  }
}
</script>

<style scoped>

</style>